import errors from './errors/index.js';
import translation from './translation/index.js';
const it = {
    translation,
    errors,
};
export default Object.freeze(it);
